import React, { useState, useRef, useEffect } from 'react';

import { useGlobalReducer } from '../../contexts/GlobalContext'

import {
    ADEX_RA,
    ADEX_DEC,
    ADEX_FOV,
    SET_VIEWED_OBJECT,
    SET_SELECTED_OBJECT,
    ALADIN_SET_MOUSE,
    RELOAD_ADEX
} from '../../contexts/GlobalStateReducer'

const AladinPanel = (props) => {
    const ref = useRef();
    const [instance, setInstance] = useState(null);
    const [ my_state , my_dispatch] = useGlobalReducer()

    const setNewSkyCoords = (newSkyCoords) => {
        my_dispatch({type: ADEX_RA, adex_ra: newSkyCoords[0]})
        my_dispatch({type: ADEX_DEC, adex_dec: newSkyCoords[1]})
        my_dispatch({type: RELOAD_ADEX, reload_adex: !my_state.reload_adex})
    }

    const setNewFov = (newFov, reload_data) => {
        my_dispatch({type: ADEX_FOV, adex_fov: newFov[0]})
        if (reload_data) {
            my_dispatch({type: RELOAD_ADEX, reload_adex: !my_state.reload_adex})
        }
    }


    // only render this once when the page is mounted.
    useEffect(() => {

        if (ref.current) {
            const el = ref.current;
            setInstance(window.A.aladin(`#${el.id}`,{ survey: my_state.selected_survey, fov: my_state.fov }));
            console.log("AladinPanel mounted");

            // trigger a fetch of the data
            my_dispatch({type: RELOAD_ADEX, reload_adex: !my_state.reload_adex})

            return () => {
                console.log("AladinPanel unmounted");
                // TODO: remove listeners?
                // Check if everything is correctly cleared.

                // Destroy aladin SkyView
                el.innerHTML = "";
                setInstance(null);
            }
        }

    }, []);


    // only render this when the background survey is changed, to prevent 'flickering'
    useEffect(() => {
        if (instance) {
            console.log('useEffect for change in: my_state.selected_survey')
            if (my_state.backend_config.config) {
                my_state.backend_config.config.focus.surveys.forEach((survey_config) => {
                    // only create survey layers for hips files
                    if (survey_config['hips_name']) {
                        instance.createImageSurvey(
                            survey_config['hips_name'],
                            survey_config['hips_name'],
                            survey_config['hips_url'],
                            "equatorial",
                            13,
                            {imgFormat: survey_config['format']}
                        )
                    }
                });
            }
            instance.setImageSurvey(my_state.selected_survey)
        }
    }, [my_state.selected_survey]);


    // render on 'aladin_reload'
    useEffect(() => {

        if (instance) {
            console.log('useEffect for change in: my_state.aladin_reload')

            instance.setFov(parseFloat(my_state.adex_fov))
            instance.gotoRaDec(my_state.adex_ra, my_state.adex_dec)

            // create the catalog layer
            createLayers(instance, props.data)

            // callback when the field of view in aladin is changed
            // note: the reason for using 'zoomChanged' instead of a OnMouseWheel event on the <div> for this
            // is that OnMouseWheel causes race condition.
            // Because aladin doesn't update its fov as fast as the 'state', causing a bit of a shaky movement when zooming out.
            instance.on('zoomChanged', function() {
                let fov = instance.getFov()

                // to prevent the effect of rounding the fov when setting/reading it
                let change_ratio = Math.abs((my_state.adex_fov / fov[0])-1)
                console.log('ratio = '+change_ratio.toString())
                if (my_state.adex_fov < fov[0] && (change_ratio > 0.1)) {
                    setNewFov(fov, true)
                } else {
                    setNewFov(fov, false)
                }

            })

            // add a listener to aladin
            // define function triggered when  a source is hovered
            instance.on('objectHovered', function (object) {

                if (object) {
                    try {
                        // select the object under the mouse cursor, and store it in global state
                        my_dispatch({type: SET_VIEWED_OBJECT, viewed_object: object.data.name})
                    } catch (e) {
                    }
                }
            });

            var objClicked;
            instance.on('objectClicked', function(object) {
                var msg;
                if (object) {
                    objClicked = object;
                    object.select();
                    msg = 'You clicked object ' + object.data.name + ' located at ' + object.ra + ', ' + object.dec;
                    my_dispatch({type: SET_SELECTED_OBJECT, selected_object: object.data})
                }
                else {
                    objClicked.deselect();
                    msg = 'You clicked in void';
                }

            });

        }
    }, [my_state.aladin_reload])


    const addCirclesToOverlay = (my_overlay, object, color, size) => {
        my_overlay.add(window.A.circle(object.ra, object.dec,size, {color: color, lineWidth: 2}));
    }

    // create the catalog layer
    const createLayers = (aladin, data) => {
        aladin.removeLayers()

        let my_catalog = window.A.catalog({
            name: 'ADEX',
            shape : 'square',
            color : 'yellow',
            sourceSize: 12,
            labelColumn: my_state.label_field,
            displayLabel: my_state.show_labels,
            labelFont: '14px arial',
            labelColor: 'white',
            //onClick: 'showPopup'});
            onClick: 'showTable'});

        // loop through all the objects and add them to the appropriate layer based a property
        if (data) {
            data.forEach(function (object) {
                // draw a clickable icon for each observation
                addToCatalog(my_catalog, object)
            })

            aladin.addCatalog(my_catalog);
        }

        if (my_state.simbad_enabled) {
            let radec_string = my_state.adex_ra + ' '  + my_state.adex_dec
            aladin.addCatalog(window.A.catalogFromSimbad(radec_string, my_state.adex_fov, {color: 'lightgreen',onClick: 'showPopup'}));
            //aladin.addCatalog(window.A.catalogFromNED(radec_string, 0.05, {color: 'red',onClick: 'showPopup',shape: 'plus'}));
        }

    }

    const addToCatalog = (my_catalog, object) => {
        let source = [window.A.source(
            object.ra,
            object.dec,
            {
                id : object.id,
                name: object.name,
                dataset_id : object.dataset_id,
                collection : object.collection,
                dp_type : object.dp_type,
                activity_id : object.activity
            },
        )]

        my_catalog.addSources(source);
    }


    function handleMouseDown() {
        my_dispatch({type: ALADIN_SET_MOUSE, aladin_mouse: 'onMouseDown, start dragging'})
    }

    function handleMouseUp() {
        my_dispatch({type: ALADIN_SET_MOUSE, aladin_mouse: 'onMouseUp, end dragging => setNewSkyCoords()'})

        let radec = instance.getRaDec()

        // do not reload when it was a simple mouse click
        if (my_state.adex_ra !== radec[0]) {
            if (my_state.adex_dec !== radec[1]) {
                setNewSkyCoords(radec)
            }
        }
    }

    return (
        <div
            ref={ref}
            id='my-aladin'
            className="aladin"
            onMouseMoveCapture={handleMouseDown}
            onMouseUp={handleMouseUp}
        />
    )
}

export default AladinPanel